import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4c128c0b&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=4c128c0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c128c0b",
  null
  
)

export default component.exports